export default {
    listagem: {
        titulo_pagina: 'List of Functions',
        novo: 'Register New Function',
        table: {
            empty: 'No Function Found',
            nome: 'Name',
            url: 'URL',
            url_autenticacao: 'URL Auth',
            credencial: 'Credencial',
            classe_autenticacao: 'Authentication Class',
            classe_cloud_function: 'Cloud Function Class',
            file_format: 'File Format',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Register New Function',
            editar: 'Edit Function'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Function name eg. TITAN Google'
            },
            url: {
                label: 'URL',
                description: 'eg. http://googlecloud.com/function'
            },
            url_autenticacao: {
                label: 'Authentication URL',
                description: 'eg. http://googlecloud.com/auth'
            },
            classe_autenticacao: {
                label: 'Authentication Class',
                description: 'eg. HL7'
            },
            credencial: {
                label: 'Credencial',
                description: 'Authentication Credential'
            },
            classe_montagem: {
                label: 'Assembly Class',
                description: 'eg. HL7v3'
            },
            classe_cloud_function: {
                label: 'CloudFunction Class',
                description: 'eg. GoogleCloudFunctionHandler'
            },
            formato_arquivo: {
                label: 'File Format',
                description: ''
            },
            credencial_incluida: {
                label: 'Is the credential included in Parser?',
                description: 'This option is checked when the user and password are included in the file sent to support.'
            },
            botao_salvar : 'Save Function'
        },
        create: {
            success: 'Function successfully created!',
            error: 'Error creating function!'
        },
        update: {
            success: 'Function successfully edited!',
            error: 'Error editing function!'
        }
    }
}
